import { callApiToServer } from "../callApi";

export async function searchLanguage(
  authToken,
  searchText,
  skipNumber,
  limitNumber
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authToken,
    };

    let body = JSON.stringify({
      searchText: searchText,
    });

    let endUrl = "v1/auth/search-language/" + skipNumber + "/" + limitNumber;
    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
